module.exports = __webpack_public_path__ + "static/5-stay-alert-486c0de0bd3cbf63126592ae8a6d10a9.png";